<template>
    <section class="office-hours montserrat"
        :style="{ '--marginY': marginY, '--marginT': marginT, '--marginB': marginB }"
        aria-labelledby="office-hours-heading">
        <div class="content">
            <div class="container right">
                <div class="info">
                    <header>
                        <h2 id="office-hours-heading">Redes sociales</h2>

                    </header>
                    <ul class="social-networks">
                        <li v-for="(m,i) of media" v-bind:key="i">
                            <a :href="m.href" target="_blank" :title="m.name" :class="m.name"><i
                                    :class="m.icon"></i></a>
                        </li>
                    </ul>
                </div>
                <hr>
                <div class="info">
                    <header>
                        <h2 id="office-hours-heading">Correos electrónico</h2>
                    </header>
                    <div class="row">
                        <a href="mailto:lrpromarketing@gmail.com" title="Ir al correo electrónico">lrpromarketing@gmail.com</a>
                        <a href="mailto:servicios@lrmarketing.pro" title="Ir al correo electrónico">servicios@lrmarketing.pro</a>

                    </div>
                </div>
                <hr>
                <div class="info">
                    <header>
                        <h2 id="office-hours-heading">Telefonos</h2>
                    </header>
                    <div class="row">
                        <a href="tel:+18298073310" title="Llamar a este numero celular">+1 (829) 807-3310</a>
                        <a href="tel:+18093105972" title="Llamar a este numero celular">+1 (809) 310-5972</a>

                    </div>
                </div>
            </div>
            <div class="container-img">
                <img class="light" src="@/assets/utility/delivery.svg" title="Vector delivery" alt="delivery light">
                <img class="dark" src="@/assets/utility/delivery-dark.svg" title="Vector delivery dark" alt="delivery dark">
            </div>
            <div class="container">
                <div class="info">
                    <header>
                        <h2 id="office-hours-heading">Horario de Oficina</h2>
                        <p>Consulta nuestros horarios de atención para planificar tu cita.</p>
                    </header>
                    <div class="row">
                        <div class="element" v-for="(day, index) in days" :key="index">
                            <div class="text">{{ day.name }}</div>
                            <div class="data">{{ day.hours }}</div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>

    </section>
</template>

<script>
import mediaData from "@/data/socialMedia.json"
export default {
    name: 'OfficeHoursComponent',
    props: {
        marginY: {
            type: String,
        },
        marginT: {
            type: String
        },
        marginB: {
            type: String
        },
    },

    data() {
        return {
            media: mediaData,
            days: [
                { name: 'Lun - vie', hours: '8:00 AM - 5:00 PM' },
                { name: 'Sabados', hours: '8:00 PM - 1 PM' },
                { name: 'Domingos', hours: 'Cerrado' },
            ]
        };
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

body.dark-theme .office-hours {
    .content {
        .container {

            &.right {

                .info {
                    h2 {
                        // color:#e8505b;
                    }
                    .row {
                        p {
                            color: #b8b8b8
                        }
                        a {
                            // color: #3dd68c
                            color: #cf7606
                        }
                    }
                }
            }

            hr {
                border: 1px solid #252525;
            }

            .info {

                .social-networks {

                    li {
                        border-radius: 20px;
                        padding: 20px;
                        background: #202127;

                        a {
                            color: #b5b5b5;

                            &:hover {
                                color: white;
                            }
                        }
                    }
                }

                header {

                    h2 {
                        color: white;
                    }

                    p {
                        color: #959595;
                    }
                }

                .row {

                    .element {

                        .text {
                            color: white;
                        }

                        .data {
                            color: #3dd68c;
                        }
                    }
                }
            }
        }

        .container-img {
            img.light {
                display: none;
            }

            img.dark {
                display: inline;
            }
        }
    }
}

.office-hours {

    padding: 0 20px;
    width: 100%;
    margin: var(--marginY) 0;
    margin-bottom: var(--marginB);
    margin-top: var(--marginT);

    .content {
        width: 80%;
        max-width: 1280px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 30px 10px;

        @media (max-width: $breakpoint-md) {
            width: 90%;
            justify-content: center;
            text-align: center;
        }


        .container {
            min-width: 300px;
            max-width: 400px;
            display: flex;
            flex-wrap: wrap;
            gap: 30px 0;
            flex: 1;

            @media (max-width: $breakpoint-md) {
                order: 1;
                width: 100%;
                min-width: 100%;
            }

            &.right {
                @media (min-width: $breakpoint-lg) {
                    text-align: right;
                }

                .info {
                    .social-networks {
                        @media (min-width: $breakpoint-lg) {
                            justify-content: end;
                        }

                        li {
                            border-radius: 20px;
                            padding: 20px;

                            a {
                                color: #b5b5b5;

                                &:hover {
                                }
                            }
                        }


                    }

                    .row {
                        p {
                            width: 100%;

                            @media (min-width: $breakpoint-lg) {
                                text-align: right;
                            }
                        }
                        a {
                            width:100%;
                            color:#e8505b;
                            font-weight: 600;
                            @media (min-width: $breakpoint-lg) {
                                text-align: right;
                            }
                            text-decoration: none;
                        }
                    }
                }
            }

            hr {
                width: 100%;
                border-top-width: 0;
                border-left-width: 0;
                border-right-width: 0;
            }

            .info {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                gap: 5px 0;

                .social-networks {
                    display: flex;
                    gap: 15px;
                    width: 100%;
                    list-style: none;

                    @media (max-width: $breakpoint-md) {
                        justify-content: center;
                    }

                    li {
                        a {
                            font-size: 1.6rem;
                            color: #616161;

                            &.Facebook {
                                color: rgb(19, 0, 226);
                            }

                            &.Instagram {
                                color: rgb(84, 41, 0);
                            }

                            &.Youtube {
                                color: rgb(166, 0, 0);
                            }
                            &.Tiktok {
                                color: rgb(25, 24, 24);
                            }

                            
                        }
                    }
                }

                header {
                    width: 100%;


                    h2 {
                        font-size: 1.6rem;
                        margin-bottom: 10px;
                    }

                    p {
                        font-size: 1rem;
                        color: #555;
                    }
                }

                .row {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;

                    .element {
                        width:100%;
                        margin-top: 20px;

                        @media (max-width: $breakpoint-md) {
                            width: 100%;
                            min-width: 100%;
                        }

                        .text {
                            font-size: 1rem;
                            margin-bottom: 5px;
                        }

                        .data {
                            font-size: 1.2rem;
                            font-weight: bold;
                            color: #1e1e1e;
                        }
                    }
                }
            }
        }

        .container-img {
            img.light {
                display: inline;
            }

            img.dark {
                display: none;
            }
        }
    }
}
</style>